import React, { type ReactNode } from "react";
import { Route } from "react-router";
import type { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum";
import RequestQueue from "../Components/UI/RequestQueue/RequestQueue";
import RequestQueueHistory from "../Components/UI/RequestQueue/RequestQueueHistory";
import { RedirectKeepingQuery } from "./RedirectKeepingQuery";
import type { RequestQueueRoutes } from "./RequestQueueRoutes";
import type { RoutePathMap } from "./useRoutePaths";

interface RequestQueueRoutesConfig {
  app: PicoAppEnum;
  apiUrl: string;
  paths: RoutePathMap<typeof RequestQueueRoutes>;
  /** Left out by apps that already sit behind RequireAuth. */
  signedOut?: boolean;
  signedOutFallback?: ReactNode;
  /** pico-com renders the cross-app hub here; everywhere else the bare path is the app's own queue. */
  hub?: ReactNode;
}

export function renderRequestQueueRoutes({
  app,
  apiUrl,
  paths,
  signedOut,
  signedOutFallback,
  hub,
}: RequestQueueRoutesConfig): React.ReactElement[] {
  const guarded = (page: ReactNode): ReactNode => (signedOut ? signedOutFallback : page);

  return [
    <Route
      key="request-queue"
      path={paths.REQUEST_QUEUE}
      element={hub ? guarded(hub) : <RedirectKeepingQuery to={paths.REQUEST_QUEUE_MINE} />}
    />,
    <Route
      key="request-queue-mine"
      path={paths.REQUEST_QUEUE_MINE}
      element={guarded(
        <RequestQueue apiUrl={apiUrl} app={app} historyPath={paths.REQUEST_QUEUE_HISTORY} />,
      )}
    />,
    <Route
      key="request-queue-history"
      path={paths.REQUEST_QUEUE_HISTORY}
      element={guarded(<RequestQueueHistory apiUrl={apiUrl} app={app} />)}
    />,
  ];
}
